theme.addDelegateEventListener = (
    element,
    eventName,
    selector,
    callback,
    addEventListenerParams = null
) => {
    const cb = (evt) => {
        const el = evt.target.closest(selector);
        if (!el) return;
        if (!element.contains(el)) return;
        callback.call(el, evt, el);
    };
    element.addEventListener(eventName, cb, addEventListenerParams);
    return cb;
};

const OrderThreshold = class extends HTMLElement {
    connectedCallback() {
        this.delegatedEvent = theme.addDelegateEventListener(document, 'click', '#cartform [name="checkout"], .additional-checkout-buttons input, a[href*="/checkout"]', this.handleFormSubmittingEvent.bind(this));
    }

    disconnectedCallback() {
        document.removeEventListener('click', this.delegatedEvent);
    }

    handleFormSubmittingEvent(evt) {
        let confirmationMessage = this.querySelector('.order-threshold-bar').getAttribute('data-order-threshold-progress');
        console.log("Order threshold => " + confirmationMessage);
        if (confirmationMessage != '1') {
            evt.preventDefault();
            const errMessage = this.querySelector('.order-threshold-bar__message--no-err');
            errMessage.classList.add("order-threshold-error");

            const cartDrawer = document.querySelector(".cart-drawer__content");
            if (cartDrawer){
                cartDrawer.scrollTop = 0; 
            } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
            
        }
    }
};
window.customElements.define('order-threshold', OrderThreshold);

// theme.addDelegateEventListener(this, 'change', '.cart-item__quantity-input', (evt) => {
//     this.adjustItemQuantity(evt.target.closest('.cart-item'), { currentValue: true });
// });